(function () {
  'use strict';

  /* @ngdoc object
   * @name people.edit
   * @description
   *
   */
  angular
    .module('people.edit', [
      'ui.router'
    ]);
}());
